var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSearch = function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m14.24 15.24-1.62-1.62-.45.3c-.97.64-1.92.9-3.29.9A5.84 5.84 0 0 1 3.1 8.86c0-2.53 2-5.04 4.47-5.61a8.2 8.2 0 0 1 2.93.03 5.9 5.9 0 0 1 3.5 8.75l-.34.54 1.62 1.63 1.62 1.64-.52.51-.51.52zm-3.3-2.3a4.37 4.37 0 0 0 2.11-2.14c.26-.56.3-.78.3-1.83 0-1.09-.03-1.27-.32-1.85a4.33 4.33 0 0 0-2.11-2.13c-.82-.4-.95-.43-1.91-.43-.93 0-1.12.04-1.8.36a4.42 4.42 0 0 0-1.47 7.07 4.16 4.16 0 0 0 3.46 1.4c.74-.03 1.02-.1 1.73-.46z"
  })));
};
export default SvgIconSearch;